import React, { useState } from 'react';
import { Heart, Star, Navigation, User } from 'lucide-react';
import VehicleModal from './VehicleModal';
import { getImageUrl } from '../../utils/imageUtils';

const VehicleCard = ({ vehicle, isLoggedIn, onLoginClick }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };

  return (
    <>
      <div 
        onClick={() => setShowModal(true)}
        className="bg-slate-900 rounded-2xl overflow-hidden hover:shadow-xl hover:shadow-black/30 transition duration-300 group cursor-pointer"
      >
        {/* Image avec overlay */}
        <div className="relative h-48">
          <img 
            src={getImageUrl(vehicle.image) || 'https://via.placeholder.com/400x300?text=No+Image'} 
            alt={`${vehicle.make} ${vehicle.model}`} 
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/400x300?text=No+Image';
            }}
          />
          
          {/* Favorite Button */}
          <button 
            onClick={handleFavoriteClick}
            className="absolute top-3 right-3 z-10 bg-black/20 backdrop-blur-sm p-2 rounded-full transition hover:bg-black/40"
          >
            <Heart 
              className={`w-5 h-5 transition ${isFavorite ? 'fill-red-500 text-red-500' : 'text-white/80'}`} 
            />
          </button>

          {/* Gradient Overlay en bas - léger */}
          <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
          
          {/* Titre sur l'image */}
          <div className="absolute bottom-3 left-4 right-4">
            <h3 className="font-bold text-xl text-white">{vehicle.model}</h3>
            <p className="text-sm text-gray-300">
              {vehicle.transmission === 'Automatique' ? 'automatic' : 'manual'} • {vehicle.make} • {vehicle.seats} Seats
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="px-4 py-3">
          {/* Rating & Price Row */}
          <div className="flex items-center justify-between mb-3">
            {/* Rating */}
            <div className="flex items-center gap-1.5 bg-slate-800 px-2.5 py-1 rounded-lg">
              <Star className="w-4 h-4 fill-[#F5A623] text-[#F5A623]" />
              <span className="text-white font-semibold text-sm">
                {(typeof vehicle.rating === 'number' && !isNaN(vehicle.rating) ? vehicle.rating : 4.5).toFixed(1)}
              </span>
            </div>
            
            {/* Price */}
            <div className="flex items-baseline">
              <span className="text-[#27489E] font-bold text-lg">MAD {vehicle.price.toFixed(2).replace('.', ',')} </span>
              <span className="text-gray-500 text-sm">/day</span>
            </div>
          </div>

          {/* Location & Owner Row */}
          <div className="flex items-center justify-between text-sm">
            {/* Location */}
            <div className="flex items-center gap-2 text-gray-400">
              <Navigation className="w-4 h-4 text-[#27489E]" />
              <span className="truncate max-w-[180px]">
                {typeof vehicle.location === 'string' 
                  ? vehicle.location 
                  : (vehicle.location?.city || vehicle.vehicleLocation?.cityName || 'N/A')}, Maroc, ...
              </span>
            </div>
            
            {/* Owner */}
            <div className="flex items-center gap-1.5 text-gray-400">
              <User className="w-4 h-4" />
              <span>Par - {vehicle.agency.name.split(' ').pop()}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <VehicleModal 
          vehicle={vehicle} 
          onClose={() => setShowModal(false)}
          isLoggedIn={isLoggedIn}
          onLoginClick={onLoginClick}
        />
      )}
    </>
  );
};

export default VehicleCard;
